const isAdmin = (user) => {
    const roles = user?.[process.env.REACT_APP_AUTH0_ROLES_CLAIM];
    return Array.isArray(roles) && roles.includes('admin');
};

export default isAdmin;
